export const dispatchHSEvents = (
    event: "identify" | "trackPageView" | "trackCustomBehavioralEvent",
    pathname?: string,
    eventProperties?: { [key: string]: string | null },
    app: "checkout" | "enrol" = "checkout",
    hubspotEventCheckout: string = "",
    hubspotEventEnrol: string = ""
) => {
    const _hsq = (window._hsq = window._hsq || []);

    /**
     * Identifying a visitor.
     */
    if (event === "identify") {
        _hsq.push(["identify", eventProperties]);
    }

    /**
     * Manually track page views of the identified visitor.
     */
    if (event === "trackPageView") {
        _hsq.push(["setPath", pathname!]);
        _hsq.push(["trackPageView"]);
    }

    if (app === "checkout") {
        /**
         * Track specific activities completed by the identified visitor.
         */
        if (event === "trackCustomBehavioralEvent") {
            _hsq.push([
                "trackCustomBehavioralEvent",
                {
                    name: hubspotEventCheckout,
                    properties: eventProperties
                }
            ]);
        }
    }

    if (app === "enrol") {
        /**
         * Track specific activities completed by the identified visitor.
         */
        if (event === "trackCustomBehavioralEvent") {
            _hsq.push([
                "trackCustomBehavioralEvent",
                {
                    name: hubspotEventEnrol,
                    properties: eventProperties
                }
            ]);
        }
    }
};
